import React from "react";
import { Tag } from "antd";
import { StopOutlined, ClockCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import { ArrowUpOutlined, ArrowDownOutlined, CloseCircleOutlined } from "@ant-design/icons";

import { NIBSSTransactionStatus } from "models";

interface ITransactionNIBSSProps {
  status: NIBSSTransactionStatus;
}

const TransactionNIBSS: React.FC<ITransactionNIBSSProps> = ({ status }) => {
  return (
    <React.Fragment>
      {status?.toLowerCase() === "successful" ? (
        <Tag
          color="success"
          icon={<ArrowUpOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "debit successful" ? (
        <Tag
          color="success"
          icon={<ArrowDownOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "credit successful" ? (
        <Tag
          color="success"
          icon={<ArrowUpOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "debit returned" ? (
        <Tag
          color="orange"
          icon={<ArrowDownOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "credit returned" ? (
        <Tag
          color="gold"
          icon={<ArrowUpOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "pending" ? (
        <Tag
          color="orange"
          icon={<ClockCircleOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "not_valid" ? (
        <Tag
          color="red"
          icon={<MinusCircleOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          not valid
        </Tag>
      ) : status?.toLowerCase() === "rejected" ? (
        <Tag
          color="error"
          icon={<CloseCircleOutlined />}
          style={{ width: "110px", textAlign: "center" }}
        >
          {status}
        </Tag>
      ) : status?.toLowerCase() === "not treated" ? (
        <Tag
          color="magenta"
          icon={<StopOutlined />}
          style={{ paddingRight: 5, paddingLeft: 5, textAlign: "center" }}
        >
          {status?.toLowerCase()}
        </Tag>
      ) : (
        <Tag
          color="default"
          style={{
            paddingRight: 5,
            paddingLeft: 5,
            textAlign: "center",
            display: status ? "inline" : "none",
          }}
        >
          {status?.toLowerCase()}
        </Tag>
      )}
    </React.Fragment>
  );
};

export default TransactionNIBSS;
